import React, { useState, useEffect, useCallback } from "react";
import { BsEyeSlashFill } from "react-icons/bs";
import { TbGps } from "react-icons/tb";
import PreviewEmailModal from "../preview-email/previewEmail";
import { toast } from "react-hot-toast";
import { sendEmailAPI } from "Api/emailAPI";
import { consoleLog } from "helpers";

const EMAIL_TYPE_MAPPING = {
  "booking.confirm.email": "BOOKING_CONFIRM",
  "ticket.confirm.email": "TICKET_CONFIRM",
  "hotel.rebookConfirm.email": "HOTEL_REBOOK_CONFIRM",
  "hotel.cancel.email": "HOTEL_CANCEL",
  "hotel.rebook.email": "HOTEL_REBOOK",
  "flight.confirm.email": "FLIGHT_REBOOK_CONFIRM",
  "flight.cancel.email": "FLIGHT_CANCEL",
  "flight.rebook.email": "FLIGHT_REBOOK",
  "flight.template.email": "FLIGHT_TEMPLATE",
  "welcome.user.email": "WELCOME",
  "reset.pwd.email": "RESETPASSWORD",
  "update.user.email": "PROFILEUPDATE",
};

const mapEmailType = (rawType = "") => {
  return EMAIL_TYPE_MAPPING[rawType] || rawType.toUpperCase();
};


const PreviewResendBtn = ({ selectedRowData, data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  consoleLog([setIsModalOpen])
  consoleLog([isModalOpen])
  const [formData, setFormData] = useState({
    emailId: "",
    subject: "",
    emailType: "",
    itineraryId: "",
    isPreview: true,
  });

  const [isOpenPreviewModal, setIsOpenPreviewModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedRowData) {
      setFormData({
        emailId: selectedRowData.emailId || "",
        subject: selectedRowData.subject || "",
        emailType: selectedRowData.emailType || "",
        itineraryId: selectedRowData.itineraryId || "",
        isPreview: true,
      });
    }
  }, [selectedRowData]);

  const transformToPayload = (data) => {
    return {
      email: data.emailId || "",
      itineraryId: data.itineraryId || "",
      emailType: "",
      emailTypes: mapEmailType(data.emailType),
      isPreview: true,
    };
  };

  const handleSendEmail = useCallback(async () => {
    if (isLoading) return;

    const payload = transformToPayload(selectedRowData);
    const token = localStorage.getItem("jwtToken");

    const response = await sendEmailAPI({ ...payload }, setIsLoading, token);

    if (response) {
      toast.success("Email sent successfully");
      setFormData({
        emailId: "",
        subject: "",
        emailType: "",
        itineraryId: "",
        isPreview: true,
      });
    } else {
      toast.error("Failed to send email");
    }
  }, [selectedRowData, isLoading]);

  const handleSend = () => {
    handleSendEmail();
  };

  const handlePreviewEmail = useCallback(() => {
    if (isLoading) return;

    const payload = transformToPayload(selectedRowData);
    setFormData((prev) => ({
      ...prev,
      ...payload,
      isPreview: true,
    }));

    setIsOpenPreviewModal(true);
  }, [selectedRowData, isLoading]);

  // const handleDeleteClick = () => {
  //   setIsModalOpen(true);
  // };

  return (
    <div className="flex gap-4">
      <BsEyeSlashFill
        className="cursor-pointer fill-white-600 w-6 h-6"
        onClick={handlePreviewEmail}
      />
      <TbGps
        className="cursor-pointer fill-white-200 w-6 h-6"
        onClick={handleSend}
      />

      <PreviewEmailModal
        isOpen={isOpenPreviewModal}
        onClose={() => setIsOpenPreviewModal(false)}
        previewEmailFormData={formData}
      />
    </div>
  );
};

export default PreviewResendBtn;
